<div class="smart-tag-form-component">
    <label class="lbl-title">
        Capture SmartTag Info
        <span class="instructions">Complete or Discard to capture again</span>
    </label>

    <div class="flex-container mb-3">
        <div>
            <label class="lbl-info">SmartTag Type</label>
            <cv-cascader #cvCascader
                    [configOptions]="cascaderConfigOptions"
                    [items]="smartTagTypeList"
                    [value]="element"
                    (valueChange)="onSelectSmartTag($event)"
                    placeholder="Select Item">
            </cv-cascader>
        </div>
    </div>

    <div class="smart-tags-info-component-scrollable">
        <div class="smart-tag-form-container">

            <div *ngIf="smartTagTemplate === smartTagTemplateType.ASSET">
                <cv-schema-render-smart-tag-assets-template
                        [smartTagModel]="smartTagData"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-assets-template>
            </div>

            <div *ngIf="smartTagTemplate === smartTagTemplateType.DEFAULT">
                <cv-schema-render-smart-tag-default-template
                        [smartTagModel]="smartTagData"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-default-template>
            </div>

            <div *ngIf="smartTagTemplate === smartTagTemplateType.UPDATE">
                <cv-schema-render-smart-tag-update-template
                        [smartTagModel]="smartTagData"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-update-template>
            </div>

            <div *ngIf="smartTagTemplate === smartTagTemplateType.VIEW">
                <cv-schema-render-smart-tag-views-template
                        [smartTagModel]="smartTagData"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-views-template>
            </div>

            <!-- CUSTOM TEMPLATES START -->
            <div *ngIf="smartTagTemplate === smartTagTemplateType.INGROUND_POOL">
                <cv-schema-render-smart-tag-pool-template
                        [smartTagModel]="smartTagData"
                        [selectedSmartTagItem]="selectedSmartTagItem"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-pool-template>
            </div>

            <div *ngIf="smartTagTemplate === smartTagTemplateType.ROAD">
                <cv-schema-render-smart-tag-road-template
                        [smartTagModel]="smartTagData"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-road-template>
            </div>

            <div *ngIf="smartTagTemplate === smartTagTemplateType.CONVERTED_GARAGE">
                <cv-schema-render-smart-tag-converted-garage-template
                        [smartTagModel]="smartTagData"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-converted-garage-template>
            </div>
            <!-- CUSTOM TEMPLATES END -->

            <!-- New Smart Tags START -->

            <div *ngIf="smartTagTemplate === smartTagTemplateType.COMPROMISE">
                <cv-schema-render-smart-tag-compromise-template
                        [smartTagModel]="smartTagData"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-compromise-template>
            </div>

            <div *ngIf="smartTagTemplate === smartTagTemplateType.DEFICIENCY">
                <cv-schema-render-smart-tag-deficiency-template
                        [smartTagModel]="smartTagData"
                        [selectedSmartTagItem]="selectedSmartTagItem"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-deficiency-template>
            </div>

            <div *ngIf="smartTagTemplate === smartTagTemplateType.POOL_TYPE">
                <cv-schema-render-smart-tag-pool-type-template
                        [smartTagModel]="smartTagData"
                        [selectedSmartTagItem]="selectedSmartTagItem"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-pool-type-template>
            </div>

            <div *ngIf="smartTagTemplate === smartTagTemplateType.FEATURES">
                <cv-schema-render-smart-tag-features-template
                        [smartTagModel]="smartTagData"
                        [selectedSmartTagItem]="selectedSmartTagItem"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-features-template>
            </div>

            <div *ngIf="smartTagTemplate === smartTagTemplateType.MATERIALS">
                <cv-schema-render-smart-tag-materials-template
                        [smartTagModel]="smartTagData"
                        [selectedSmartTagItem]="selectedSmartTagItem"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-materials-template>
            </div>

            <div *ngIf="smartTagTemplate === smartTagTemplateType.WINDOWS">
                <cv-schema-render-smart-tag-windows-template
                        [smartTagModel]="smartTagData"
                        [selectedSmartTagItem]="selectedSmartTagItem"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-windows-template>
            </div>

            <div *ngIf="smartTagTemplate === smartTagTemplateType.SURFACE">
                <cv-schema-render-smart-tag-surface-template
                        [smartTagModel]="smartTagData"
                        [selectedSmartTagItem]="selectedSmartTagItem"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-surface-template>
            </div>

            <div *ngIf="smartTagTemplate === smartTagTemplateType.SPACE">
                <cv-schema-render-smart-tag-space-template
                        [smartTagModel]="smartTagData"
                        [selectedSmartTagItem]="selectedSmartTagItem"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-space-template>
            </div>

            <div *ngIf="smartTagTemplate === smartTagTemplateType.UPDATE_TYPE">
                <cv-schema-render-smart-tag-update-type-template
                        [smartTagModel]="smartTagData"
                        [selectedSmartTagItem]="selectedSmartTagItem"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-update-type-template>
            </div>

            <div *ngIf="smartTagTemplate === smartTagTemplateType.FENCE">
                <cv-schema-render-smart-tag-fence-template
                        [smartTagModel]="smartTagData"
                        [selectedSmartTagItem]="selectedSmartTagItem"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-render-smart-tag-fence-template>
            </div>
            <!-- New Smart Tags END -->

            <div *ngIf="smartTagTemplate === smartTagTemplateType.RENDER_FORM_RENDER">
                <cv-schema-form-render
                        [smartTagModel]="smartTagData"
                        [selectedSmartTagItem]="selectedSmartTagItem"
                        (valueChange)="validateData($event)"
                >
                </cv-schema-form-render>
            </div>
        </div>
    </div>
</div>
